import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';

import AdminRolesModal from '../AdminRolesModal';
import CommonTable from '../../CommonTable/CommonTable';
import Link from '../../Link';
import CustomPagination from '../../CustomPagination';
import Loader from '../../Loader/Loader';

import adminRolesQuery from './adminRolesQuery.graphql';
import messages from '../../../locale/messages';
import { openAdminRolesModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';
import { withQuery } from '../../../hoc/withGraphql';

import s from './AdminRolesManagement.css';
import bt from '../../../components/commonStyle.css';

class AdminRolesManagement extends React.Component {

  static defaultProps = {
    data: []
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: ''
    }
  }

  handleSearchChange = (searchList) => {
    const { data: { refetch } } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);
  }

  paginationData = (currentPage) => {
    const { data: { refetch } } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage, searchList };
    this.setState({ currentPage, searchList });
    refetch(variables);
  }

  handleModalOpen = (value) => {
    const { openAdminRolesModal } = this.props;
    if (value) openAdminRolesModal('edit', value)
    else openAdminRolesModal('add')
  }

  handleDelete = async (id, currentPage) => {
    const { deleteAdminRole, setStateVariable, data: { refetch, getAllAdminRoles } } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage: currentPage > 1 && getAllAdminRoles?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    const deleteValue = await deleteAdminRole(id, currentPage);
    if (deleteValue?.status === 200) {
      this.setState({ currentPage: variables.currentPage });
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.name) },
      { data: formatMessage(messages.descriptionAdminLabel) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }

  tbody = (props) => {
    const { data: { getAllAdminRoles } } = props;
    const { currentPage } = this.state;

    return getAllAdminRoles?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value?.id, },
          { data: value?.name },
          { data: value?.description },
          { data: <Link noLink onClick={() => this.handleModalOpen(value)}><FormattedMessage {...messages.editLabel} /></Link> },
          { data: <Link noLink onClick={() => this.handleDelete(value?.id, currentPage)}><FormattedMessage {...messages.delete} /></Link> }
        ]
      }
    })
  }

  render() {
    const { currentPage } = this.state;
    const { data: { getAllAdminRoles, loading } } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        {loading && <div><Loader type={"text"} /></div>}

        {!loading && <div>
          <AdminRolesModal paginationData={this.paginationData} currentPage={currentPage} />
          <CommonTable
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            isSearch
            isSearchAdd
            handleSearch={(e) => this.handleSearchChange(e?.target?.value)}
            title={formatMessage(messages.manageAdminRoles)}
            addAction={() => this.handleModalOpen()}
            redirectionLabel={formatMessage(messages.addNewLabel)}
          />
          {
            getAllAdminRoles?.count > 0 &&
            <CustomPagination
              total={getAllAdminRoles?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.roles)}
              isScroll
            />
          }
        </div>}
      </div>
    )
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminRolesModal,
  deleteAdminRole
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(adminRolesQuery, {
    options: (props) => ({
      variables: {
        searchList: '',
        currentPage: props.currentPage
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(AdminRolesManagement);